import { useParams, useLocation } from "react-router-dom";
import { useState } from "react";
import { categoryApi } from "../../../api/categoryApi";
import { storageApi } from "../../../api/storageApi";
import { ResourceType } from "../../../Constants/ResourceType";
import { useLoading } from "../../../context/LoadingContext";
import { useAlert } from "../../../context/AlertContext";
export default function CategoryEditPage() {
    const { id } = useParams();
    const { state } = useLocation();
    console.log(JSON.stringify(state));

    const [name, setName] = useState(state?.name || "");
    const [description, setDescription] = useState(state?.description || "");
    const [file, setFile] = useState(null);
    const [imageUrl, setImageUrl] = useState(state?.imageUrl || null);
    const [imageId, setImageId] = useState(state?.fileId || null);
    const {showLoading, hideLoading} = useLoading();
    const {showAlert} = useAlert();


    const handleSubmit = (e) => {
        e.preventDefault();
        try {
            showLoading()
            const param = {
                id: id,
                name: name,
                desc: description,
                fileId: imageId
            };
            console.log("Submit update:", { id, name, description, file });

            // Gửi API: fetch(..., { method: "PUT", body: form })
            if (file) {
                const form = new FormData();
                form.append("resourceId", id);
                form.append("resourceType", ResourceType.Category);
                form.append("file", file);
                storageApi.uploadImage(id, ResourceType.Category, form).then((res) => {
                    console.log("Image uploaded:", res);
                })
            }
            categoryApi.update(id, param).then((res) => {
                showAlert('success',"success update category");
                console.log(`res update ${res}`);
                window.history.back();
            })
        }
        finally {
            hideLoading()
        }
    };
    const handleChangeImage = async (e) => {
        try {
            showLoading()
            const file = e.target.files?.[0];
            if (file) {
                const form = new FormData();
                form.append("file", file);
                var res = await storageApi.uploadTemptFile(form);
                if (res.success) {
                    const data = res.data;
                    const url = data.url;
                    setImageUrl(url);
                    setImageId(data.id);
                }
            }
        }
        finally {
            hideLoading()
        }
    }
    return (
        <div className="container mt-4" style={{ maxWidth: "600px" }}>
            <h3 className="mb-3">Edit Category #{id}</h3>

            <form onSubmit={handleSubmit}>

                {/* Name */}
                <div className="mb-3">
                    <label className="form-label fw-bold">Name</label>
                    <input
                        className="form-control"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </div>

                {/* Description */}
                <div className="mb-3">
                    <label className="form-label fw-bold">Description</label>
                    <textarea
                        className="form-control"
                        rows="3"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </div>

                {/* File Upload */}
                <label className="form-label fw-bold">Image</label>
                <div className="mb-3 d-flex justify-content-start align-items-center gap-2">
                    <div>
                        <input
                            className="form-control"
                            type="file"
                            accept="image/*"
                            onChange={handleChangeImage}
                        />
                    </div>
                    <div>
                        <button className="btn btn-primary">Auto gen</button>
                    </div>
                </div>

                {/* Preview Image */}
                {imageUrl && (
                    <div className="mb-3">
                        <img
                            src={imageUrl}
                            alt="preview"
                            style={{
                                width: "100%",
                                borderRadius: "8px",
                                objectFit: "cover",
                            }}
                        />
                    </div>
                )}

                {/* Save */}
                <button type="submit" className="btn btn-primary me-2">
                    Save Changes
                </button>

                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => window.history.back()}
                >
                    Cancel
                </button>

            </form>
        </div>
    );
}
